import React from "react";
import useVoiceAssistant from "./useVoiceAssistant";
import { AnimatePresence } from "framer-motion";

const HeroSection = ({ equalizerCanvasRef }) => {
  const { renderLoadingView, renderInteractiveView, isLoading } =
    useVoiceAssistant();

  return (
    <section className="min-h-screen flex items-center justify-center text-center px-4 py-24">
      <div className="absolute inset-0 z-0 opacity-70">
        <canvas ref={equalizerCanvasRef}></canvas>
        <div
          className="absolute inset-x-0 bottom-0 h-48"
          style={{
            background:
              "linear-gradient(to top, rgba(13, 28, 93, 1) 10%, rgba(29, 78, 216, 0) 100%)",
          }}
        ></div>
      </div>
      <div className="relative z-10">
        <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight">
          AI-Powered Hotel
        </h1>
        <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight mt-2">
          Management System
        </h1>
        <div className="mt-20">
          <div >
            <AnimatePresence mode="wait">
              {isLoading ? renderLoadingView() : renderInteractiveView()}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
